import React from "react";
import Head from "next/head";

import ProductGrid, { useEndpoint } from "modules/product-grid";
import { Breadcrumbs } from "ui/breadcrumbs";
import { isId } from "utils/string";
import { useTranslations } from "next-intl";

export default function LectorPage({ listId, listName, products, routeKey }) {
  const t = useTranslations();

  return (
    <>
      <Head>
        <title>{t("meta.lector.title", { lector: listName })}</title>
        <meta name="description" content={t("meta.lector.description", { lector: listName })} />
      </Head>
      <Breadcrumbs items={[{ name: listName }]} />
      <ProductGrid listId={listId} listName={listName} products={products} routeKey={routeKey} />
    </>
  );
}

export const getServerSideProps = useEndpoint("/v2/lectors/{id}", (id) => (isId(id) ? id : `slug/${id}`));
